export default "__VITE_ASSET__CLB9MYWa__"